import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";

const WP_API = "/api/wp/wp-json";
const RED    = '#DC143C';
const DARK   = '#0a0404';
const BORDER = 'rgba(255,255,255,0.1)';
const MUTED  = 'rgba(255,255,255,0.35)';
const WHITE  = '#ffffff';

export default function RedefinirSenha() {
  const [searchParams]          = useSearchParams();
  const navigate                = useNavigate();
  const token                   = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [error, setError]       = useState("");
  const [done, setDone]         = useState(false);
  const [busy, setBusy]         = useState(false);

  useEffect(() => {
    if (!token) setError("Link inválido. Solicite um novo.");
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("As senhas não coincidem"); return; }
    if (password.length < 8)  { setError("Senha deve ter no mínimo 8 caracteres"); return; }
    setBusy(true);
    try {
      const res = await fetch(`${WP_API}/rr/v1/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Erro ao redefinir senha");
      setDone(true);
      setTimeout(() => navigate("/entrar"), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: DARK, padding: "40px 24px" }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 9, fontWeight: 700, color: RED, letterSpacing: "0.25em", textTransform: "uppercase", marginBottom: 14 }}>RR Magma</div>
          <div style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 24, fontWeight: 900, color: WHITE }}>Nova senha</div>
        </div>

        {done ? (
          <div style={{ background: "rgba(34,197,94,0.08)", border: "1px solid rgba(34,197,94,0.2)", borderRadius: 8, padding: "28px", textAlign: "center" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>✓</div>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "#22c55e", fontWeight: 700, letterSpacing: "0.1em", marginBottom: 10 }}>SENHA REDEFINIDA</div>
            <p style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.7 }}>
              Sua senha foi atualizada. Redirecionando para o login...
            </p>
          </div>
        ) : (
          <>
            {error && (
              <div style={{ background: "rgba(220,20,60,0.1)", border: "1px solid rgba(220,20,60,0.3)", borderRadius: 6, padding: "12px 16px", marginBottom: 16, fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: "#ff6b6b" }}>{error}</div>
            )}

            {token && (
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div>
                  <label style={{ display: "block", marginBottom: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: MUTED, letterSpacing: "0.12em", textTransform: "uppercase" }}>Nova senha</label>
                  <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 8 caracteres"
                    style={{ width: "100%", padding: "12px 14px", boxSizing: "border-box", border: `1px solid ${BORDER}`, borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, color: WHITE, background: "rgba(255,255,255,0.04)", outline: "none" }}
                  />
                </div>
                <div>
                  <label style={{ display: "block", marginBottom: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: MUTED, letterSpacing: "0.12em", textTransform: "uppercase" }}>Confirmar senha</label>
                  <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)} placeholder="Repita a senha"
                    style={{ width: "100%", padding: "12px 14px", boxSizing: "border-box", border: `1px solid ${BORDER}`, borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, color: WHITE, background: "rgba(255,255,255,0.04)", outline: "none" }}
                  />
                </div>
                <button onClick={handleSubmit} disabled={busy || !password || !confirm}
                  style={{ width: "100%", padding: "14px", background: busy || !password || !confirm ? "rgba(255,255,255,0.1)" : RED, color: WHITE, border: "none", borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase", cursor: busy || !password || !confirm ? "not-allowed" : "pointer" }}
                >{busy ? "Salvando..." : "Salvar nova senha"}</button>
              </div>
            )}

            <div style={{ marginTop: 20, textAlign: "center" }}>
              <Link to="/esqueci-senha" style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: MUTED, textDecoration: "none" }}>← Solicitar novo link</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
